import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const KayakWidget = ({ open }) => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const widgetElement = widgetRef.current;

    // Clear previous content in case it was already rendered
    if (widgetElement) {
      widgetElement.innerHTML = '';
    }

    // Re-run the Kayak widget script
    if (document.getElementById('kayak-widget-script')) {
      // Re-initialize by creating a new script instance
      const newScript = document.createElement('script');
      newScript.src = 'https://www.kayak.com/search-widget/script/direct/kayak';
      newScript.async = true;
      document.body.appendChild(newScript);

      // Cleanup newly injected script after some time (optional)
      // eslint-disable-next-line consistent-return
      return () => {
        document.body.removeChild(newScript);
      };
    }
    const script = document.createElement('script');
    script.src = 'https://www.kayak.com/search-widget/script/direct/kayak';
    script.id = 'kayak-widget-script';
    script.async = true;
    document.body.appendChild(script);
  }, [open]);

  return (
    <div
      ref={widgetRef}
      id="kayak"
      data-affiliate-id="kan_313962"
      data-theme="light"
      data-language-code="en"
      data-country-code="US"
      data-currency-code="USD"
      data-vertical="hotels"
      data-vertical-list="hotels,cars,packages,flights"
      data-fill-trip-type="2"
      data-label=""
      data-disable-compare-to="true"
      data-auto-height="true"
    />
  );
};

KayakWidget.propTypes = {
  open: PropTypes.bool
};

export default KayakWidget;
